/**
 * Build a wa.me link from a Portuguese-formatted phone number.
 *   "+351 911 222 333" → "https://wa.me/351911222333"
 *   "911 222 333"      → "https://wa.me/351911222333"   (default Portugal prefix)
 * Returns null if not enough digits.
 */
export function whatsappLink(phone, defaultCountry = "351") {
  if (!phone) return null;
  // Keep only digits; if user already wrote "+...", the plus is dropped (wa.me accepts no +)
  const digits = String(phone).replace(/\D+/g, "");
  if (!digits || digits.length < 7) return null;
  // If the user wrote a local 9-digit Portuguese number, prepend the country code.
  const final = digits.length === 9 ? defaultCountry + digits : digits;
  return `https://wa.me/${final}`;
}
